module.exports = __webpack_public_path__ + "static/img/tit55.738dbf69.png";